import React from 'react';
import Tooltip from '@mui/material/Tooltip';

interface CustomTooltipProps {
    title: string;
    children: React.ReactElement;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ title, children }) => {
    return (
        <Tooltip
            title={title}
            arrow
            componentsProps={{
                popper: {
                    modifiers: [{ name: 'offset', options: { offset: [0, 10] } }],
                },
                tooltip: {
                    sx: {
                        backgroundColor: 'primary.main',
                        color: 'white',
                        padding: 2,
                        fontSize: '0.8rem',
                        fontWeight: 'bold',
                        borderRadius: 2,
                        boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.8)',
                    },
                },
                arrow: { sx: { color: 'primary.main' } },
            }}
        >
            {children}
        </Tooltip>
    );
};

export default CustomTooltip;
